import React from "react";
import PropTypes from "prop-types";

const LOCAL_URL = "http://localhost:8080";
const PROD_URL = "https://player.myplay.com/";

const BaseVideoPlayer = ({
  iframeUrl,
  type,
  srcId,
  isHighlight,
  height,
  width,
  accountType,
  disableFullscreen
}) => {
  const src =
    isHighlight === undefined
      ? `${iframeUrl}?${type}=${srcId}&accountType=${accountType}&disableFullscreen=${disableFullscreen}`
      : `${iframeUrl}?${type}=${srcId}&clip=true`;

  const iframeSize = { height, width, minHeight: "260px" };

  return (
    <iframe
      className="baseVideoPlayer"
      src={src}
      allowFullScreen
      style={iframeSize}
    />
  );
};

BaseVideoPlayer.propTypes = {
  iframeUrl: PropTypes.string.isRequired,
  /** Type of video player currently video or live */
  type: PropTypes.string.isRequired,
  srcId: PropTypes.string.isRequired,
  isHighlight: PropTypes.bool,
  /** Set the video height  */
  height: PropTypes.string.isRequired,
  /** Set the video width  */
  width: PropTypes.string.isRequired,
  /** accountType : operator/coach/player/tagger */
  accountType: PropTypes.string.isRequired
};
BaseVideoPlayer.defaultProps = {
  iframeUrl: PROD_URL ,
  height: "100%",
  width: "100%",
  accountType: "player"
};

export default BaseVideoPlayer;

// https://stream.myplay.com/mvp-dev
